import { takeLatest, all, put, select } from 'redux-saga/effects';
import ExpiredPasswordPanelActions from './actions';

import { FORM_ID } from '../index';
import { CKForm } from 'console-kit';

function* onExpiredRequestHandler({ payload: { formRef } }) {
  yield put(CKForm.Actions.validateForm(FORM_ID));
  const isValid = yield select(CKForm.Selectors.isFormValid, FORM_ID);

  if (isValid) {
    formRef.method = 'post';
    formRef.submit();
  } else {
    yield put(ExpiredPasswordPanelActions.onExpiredPasswordPanelFailure());
  }
}

function* authFormSagas() {
  yield all([takeLatest(ExpiredPasswordPanelActions.onExpiredPasswordPanelRequest.getType(), onExpiredRequestHandler)]);
}

export default authFormSagas;
